import { toInterfaceArray } from "../helpers/helpers";
import { Base } from "./Base";
import { IUnit, Unit } from "./food";
import { MealType } from "./Meal";

export class FoodRecord extends Base{
    id: string;
    name: string
    type: FoodType; //distinguish food/recipes
    logs: FoodLog[];
    weight: number; //used to sort results for predictions

    get totalCount(): number{  //return pure overall count
        return this.logs.length;
    }

    get dayOfWeekCount(): number{ //return count per today's day of week
        var count = 0;
        var today = new Date();
        var day = today.getDay();
        this.logs.forEach(log =>{
            if(log.date.getDay() == day){
                count++;
            }
        });
        return count;
    }
    get daysSinceLastSeen(): number{  //return number of days since last tracked
        if(this.logs.length == 0){ 
            return -1 //if never tracked
        }
        var count = 0;
        var today = new Date();
        today.setHours(0,0,0,0);
        var lastSeen = new Date(this.logs[this.logs.length-1].date);
        lastSeen.setHours(0,0,0,0);
        while(count <= 1000 && today.getSeconds() != lastSeen.getSeconds()){
            count++
            today.setDate(today.getDate() -1);
        }
    }

    //quick and dirty method to get most recent log
    get lastLog(){
        if(this.logs.length != 0){
            return this.logs[this.logs.length -1]; 
        }
        else return undefined;
    }

    constructor(i?: IFoodRecord){
        super();
        this.logs = [];
        if(i){
            this.id = i.id;
            this.name = i.name;
            this.type = i.type;
            this.weight = 1;
            if(i.logs){
                i.logs.forEach(element => {
                    this.logs.push(new FoodLog(element));
                });
            }
        }
    }

    getMealTypeCount(mealType: MealType): number{
        var count = 0;
        this.logs.forEach(log =>{
            if(log.mealType == mealType){
                count++;
            }
        });
        return count;
    }

    //Method calculates the rank of a food records taking into account recent usage, weekday and meal type
    calculateRank(ignoreBefore: number, recentUntil: number, recentWeight: number, day: Date, sameWeekdayWeight: number, mealType: MealType, sameMealTypeWeight: number): number{
        // console.log(" *** Calculating rank for record " + this.name + " ***")
        //Setup ignore before date and recent bonus date
        var ignoreDate = new Date(day);
        ignoreDate.setDate(day.getDate() - ignoreBefore);
        var recentDate = new Date(day);
        recentDate.setDate(day.getDate() - recentUntil);
        // console.log("Logs made before the following date are not considered:");
        // console.log(ignoreDate);
        // console.log("Logs made after the following date are weighted higher:");
        // console.log(recentDate);
        //Filter out all logs which were made before the ignore before date
        var logs = this.logs.filter(log => log.date > ignoreDate)
        // console.log("After filtering, " + logs.length + " logs are considered. Before filtering, there were " + this.logs.length + " logs.");
        var rank: number = 0;
        //Go through all logs and add a count multiplied by the weight factors for each log
        logs.forEach(log => {
            //Default count of a log is 1
            var add: number = 1;
            //Increase weight if the log happend recently
            if(log.date > recentDate) add += recentWeight;
            //Increase weight if the log happend on the same weekday as the requested day
            if(log.date.getDay() == day.getDay()) add += sameWeekdayWeight;
            //Increase weight if the log was for the same meal type as the requested one
            if(log.mealType == mealType) add += sameMealTypeWeight;
            rank += add;
        });
        // console.log("Rank result: " + rank);
        return rank;
    }

    addLog(mealType: MealType, amount: number, unit: Unit = undefined){
        console.log("adding log for "+this.name+", values: "+mealType, amount, unit);
        var newLog = new FoodLog({
            id: this.id,
            amount: amount,
            unit: unit,
            mealType: mealType
        })
        this.logs.push(newLog);
    }

    public toInterface(): IFoodRecord {
        return {id: this.id, logs: toInterfaceArray(this.logs), name: this.name, type: this.type};
    }

    
}




export class FoodLog extends Base{
    id: string; //db style, to allow for distinction with "all logs" retrievals 
    date: Date; //record date
    amount: number; // unit quantity (food) or portion (recipe)
    unit: Unit;   // unit of measurement (food-only) --> now also for recipes
    mealType: MealType  // meal used with (for hierarchy logic)
    constructor(i: IFoodLog){
        super();
        this.id = i.id;
        this.date = i.date ? new Date(i.date) : new Date();
        this.amount = i.amount;
        this.unit = new Unit(i.unit);
        this.mealType = i.mealType;
    }

    public toInterface(): IFoodLog{
        var unit = this.unit ? this.unit.toInterface() : undefined;
        return {amount: this.amount, date: this.date, id: this.id, mealType: this.mealType, unit: unit};
    }

    public equals(other: FoodLog): boolean {
        return this.id === other.id && this.date.getTime() / 1000 === other.date.getTime() / 1000 && this.amount === other.amount
            && this.unit.equals(other.unit) && this.mealType === other.mealType;
    }
}

export enum  FoodType{
    food,
    recipe,
    foodProduct
}

export interface IFoodRecord{
    id: string;
    name: string
    type: FoodType;
    logs: FoodLog[];
}

export interface IFoodLog{
    id: string;
    date?: Date;
    amount: number;
    unit: IUnit;
    mealType: MealType;
}
